import { render, staticRenderFns } from "./Listagem.vue?vue&type=template&id=66af0db8&scoped=true&lang=pug"
import script from "./Listagem.vue?vue&type=script&lang=js"
export * from "./Listagem.vue?vue&type=script&lang=js"
import style0 from "./Listagem.styl?vue&type=style&index=0&id=66af0db8&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af0db8",
  null
  
)

export default component.exports